module.exports = __webpack_public_path__ + "b797857a54042d673292be269455053c.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/level_5_rustig.mp3
// module id = 78
// module chunks = 0